import React from 'react';
import TerminalLayout from './TerminalLayout';
import { STANDALONE_CONFIG } from '../shared/TerminalConfig';

const StandaloneLayout = ({ children }) => (
  <TerminalLayout config={STANDALONE_CONFIG}>
    {children}
  </TerminalLayout>
);

export default StandaloneLayout;